import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserFunctionCode } from '../constants/UserFunctionCode';
import { FabUser } from '../models/FabUser';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  private _LOGGED_USER : FabUser;
  private _isUserAuthorized: boolean=false;
  private readonly currentUserUrl = environment.currentUserUrl;

  constructor(private readonly httpClient: HttpClient, private readonly authenticationService: AuthenticationService) {
    console.log('security service constructor ');
  }

  public can(functionCode: UserFunctionCode) : boolean{
    let functionCodes=this._LOGGED_USER.functionCodes?? new Array<string>();
    return functionCodes?functionCodes.indexOf(functionCode.trim().toString()) > -1 : false;
  }

  public getCurrentUser() : Observable<FabUser> {
    return this.httpClient.get<FabUser>(this.currentUserUrl);
  }

  public fetchCurrentUserAsPromise(): Promise<boolean> {
    console.log('security service ');
    return new Promise<boolean>((resolve, reject) => {
      firstValueFrom(this.httpClient.get<FabUser>(this.currentUserUrl))
        .then((response: FabUser) => {
            this.LOGGED_USER = response;
            console.log('resolve: userInfo: ' + this.LOGGED_USER.gmin);
          }).catch((error:HttpErrorResponse) => {
            console.log('reject: error in fetching data => '+error.error.errorMessage);
            this.LOGGED_USER={gmin:''};
          }).finally(() => {
            console.log('promise: finally ');
            resolve(true);
          });
      });
  }

  get LOGGED_USER(): FabUser {
    return this._LOGGED_USER;
  }

  set LOGGED_USER(value: FabUser) {
    let roleName=value.roleName? value.roleName:'';
    value.roles=[roleName];
    value.email=this.authenticationService.userInfo.email;
    this._LOGGED_USER = value;
    this._LOGGED_USER.lastAccessedTime=new Date();
    this._isUserAuthorized = this._LOGGED_USER.functionCodes!=null;
  }

  get isUserAuthorized(): boolean {
    return this._isUserAuthorized;
  }

  set isUserAuthorized(value: boolean) {
    this._isUserAuthorized = value;
  }
}
